import React from "react";

export const TemplatesIcon = ({ stroke = "#113357" }: { stroke?: string }) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="2" width="13.5" height="13.5" rx="2" stroke={stroke} strokeWidth="1.2" />
      <path d="M5.85714 5.85715L5.85714 15.5" stroke={stroke} strokeWidth="1.2" strokeLinecap="round" />
      <path d="M15.5 5.85715L2 5.85715" stroke={stroke} strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  );
};
